export function parseDateValue(value: unknown): Date | undefined {
  if (value === null || typeof value === "undefined") return undefined;
  try {
    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) return undefined;
      return value;
    }
    if (typeof value === "number") {
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? undefined : d;
    }
    if (typeof value === "string") {
      const parsed = Date.parse(value);
      if (!Number.isNaN(parsed)) return new Date(parsed);
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? undefined : d;
    }
    const d = new Date(String(value));
    return Number.isNaN(d.getTime()) ? undefined : d;
  } catch {
    return undefined;
  }
}
